import React, { useState } from "react";
import { Card } from "react-bootstrap";
import expand from "../images/expand.png";
import collapse from "../images/collapse.png";

function FAQs() {
  const FAQs = [
    {
      question: "What makes Algoturtle unique?",
      answer:
        "India's first AI-based algo trading platform. Develop your own strategies with us or use one of our own. Strategies available for every market condition, trending or sideways. Expiry Special (CAP) (Nifty) Amazing strategies. Unique UI.",
    },
    {
      question: "What is Algoturtle?",
      answer:
        "Algoturtle is India's first AI-based algorithmic trading platform.",
    },
    {
      question: "How can I develop my own trading strategies?",
      answer:
        "Algoturtle empowers users to craft their own trading strategies using advanced tools and resources provided on the platform.",
    },
    {
      question: "Why choose Algoturtle?",
      answer:
        "Trade like never before. Trade without emotions. Stress-free, systematic, and disciplined.",
    },
    {
      question: "Can I customize/develop strategies?",
      answer:
        "Of course YOU CAN. We specialize in custom strategies. Custom strategies are one of our higher-selling products.",
    },
    {
      question: "How do I get started?",
      answer: "Register here, and our team will contact you. REGISTER NOW.",
    },
  ];

  const [expandedIndex, setExpandedIndex] = useState(-1);

  const toggleExpand = (index) => {
    setExpandedIndex((prevIndex) => (prevIndex === index ? -1 : index));
  };

  return (
    <div className="faq-container bg-gray-100 py-12">
      <h1 className="text-center text-4xl font-extrabold text-gray-800 mb-10">
        Frequently Asked Questions
      </h1>
      <div className="max-w-4xl mx-auto space-y-6">
        {FAQs.map((faq, index) => (
          <div
            key={index}
            className={`transition-transform duration-300 ${
              expandedIndex === index ? "scale-105" : ""
            }`}
          >
            <Card
              className="overflow-hidden rounded-lg shadow-lg hover:shadow-2xl transition-shadow duration-300 faq-answer"
              onClick={() => toggleExpand(index)}
            >
              <Card.Header className="cursor-pointer flex justify-between items-center bg-[#2d3192] text-white p-5">
                <span className="font-semibold text-lg">{faq.question}</span>
                <span>
                  {expandedIndex === index ? (
                    <img
                      src={collapse}
                      alt="Collapse"
                      className="w-6 h-6 transition-transform duration-300 transform rotate-180"
                    />
                  ) : (
                    <img
                      src={expand}
                      alt="Expand"
                      className="w-6 h-6 transition-transform duration-300"
                    />
                  )}
                </span>
              </Card.Header>
              {expandedIndex === index && (
                <Card.Body className="bg-white p-6">
                  <Card.Text className="text-gray-700 text-base leading-relaxed">
                    {faq.answer}
                  </Card.Text>
                </Card.Body>
              )}
            </Card>
          </div>
        ))}
      </div>
    </div>
  );
}

export default FAQs;
